export const aside = {
    close: {
        label: "Fermer",
        title: "Fermer le panneau de sous-menu / recherche"
    }
}